(function () {
  'use strict';

  const root = document.getElementById('Pdp-FAQ-Section');

  const accordionTriggers = root ? root.querySelectorAll('.accordion_trigger') : [];
  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const accordionContent = trigger.nextElementSibling;
      if (!accordionContent) return;

      const isAccordionOpen = accordionContent.classList.contains('open');

      const openAccordions = root.querySelectorAll('.accordion_hidden_text.open');
      openAccordions.forEach((openAccordion) => {
        openAccordion.style.maxHeight = null;
        openAccordion.classList.remove('open');
        const chevron = openAccordion.previousElementSibling
          ? openAccordion.previousElementSibling.querySelector('.accordion_chevron')
          : null;
        if (chevron) chevron.style.transform = 'rotate(0deg)';
      });

      if (!isAccordionOpen) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        accordionContent.classList.add('open');
        const chevron = trigger.querySelector('.accordion_chevron');
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      }
    });
  });

  // Backward-compat: legacy template resize listener calls window.updatePdpFaqResponsive
  // Sophie-related responsive logic removed (dead code — Sophie lives in pdp-beratung section)
  // Remove after product.Productpage.liquid migration
  window.updatePdpFaqResponsive = function () {};
})();
